module.exports = __webpack_public_path__ + "e99548d9cc41b77a56a781b2011e94d2.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_1-420.webp
// module id = 567
// module chunks = 0